module.exports = __webpack_public_path__ + "ab56e2611d76d7da4c8b753a12f2ef99.png";